export const intersectionObserve = function(elements, rootMargin, threshold, onIntersectionChange) {
    if ('IntersectionObserver' in window) {
        const options = {
            root: null, // relative to document viewport
            rootMargin: '0px 0px ' + (rootMargin || 0) + 'px', // margin around root. Values are similar to css property. Unitless values not allowed
            threshold: threshold || 0 // visible amount of item shown in relation to root
        };

        const _onIntersectionChange = function (changes, observer) {
            changes.forEach(change => {
                if (onIntersectionChange) {
                    onIntersectionChange(change.target, change.intersectionRatio);
                }
            });
        };

        const observer = new IntersectionObserver(_onIntersectionChange, options);

        if (elements.forEach) {
            elements.forEach(element => observer.observe(element));
        } else {
            observer.observe(elements);
        }
    } else {
        if (elements.forEach) {
            elements.forEach(element => onIntersectionChange(element));
        } else {
            onIntersectionChange(elements);
        }
    }
};

// Lazy loading for images and background images
export const initLazyLoading = function() {
    const lazyImages = document.querySelectorAll('.lazy-image');
    const lazyBgElements = document.querySelectorAll('.lazy-bg');

    // Lazy load <img> elements
    if (lazyImages.length > 0) {
        intersectionObserve(lazyImages, 200, 0, (element, intersectionRatio) => {
            if (intersectionRatio > 0 && !element.classList.contains('lazy-loaded')) {
                const src = element.getAttribute('data-src');
                if (src) {
                    element.src = src;
                    element.removeAttribute('data-src');
                    element.classList.add('lazy-loaded');
                }
            }
        });
    }

    // Lazy load background images
    if (lazyBgElements.length > 0) {
        intersectionObserve(lazyBgElements, 200, 0, (element, intersectionRatio) => {
            if (intersectionRatio > 0 && !element.classList.contains('lazy-loaded')) {
                const bg = element.getAttribute('data-bg');
                if (bg) {
                    element.style.backgroundImage = `url(${bg})`;
                    element.removeAttribute('data-bg');
                    element.classList.add('lazy-loaded');
                }
            }
        });
    }
};

// Auto-initialize on DOMContentLoaded
if (typeof window !== 'undefined') {
    document.addEventListener('DOMContentLoaded', initLazyLoading);
}